// JsFromRoutes CacheKey fb5a0d7c93291e6406f6f4d162f78b97
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/consumer/general_places'),
}
